export enum SafetyTabs {
  Warranty = "warrantyTab",
  UsedCarWarrantyPurchased = "usedCarWarrantyPurchasedTab",
  DeclarationOfGoods = "declarationOfGoodsTab",
  ServiceHistory = "serviceHistoryTab",
  ServicePlanFollowed = "servicePlanFollowedTab",
  ExchangePolicy = "exchangePolicyTab",
  Condition = "conditionTab",
  Premium = "premiumTab",
  HomeDelivery = "homeDeliveryTab",
  TradeOrg = "tradeOrgTab",
}
